// extracted by mini-css-extract-plugin
module.exports = {"point":"_2RQX48FihOC0","link":"_LgX50oW5Rf1","airportName":"SNEQP3tbqqY8","terminal":"_1ky1G2KsLCn1"};